import Vue from "vue";

export const TaskState = {
  task: null,
  tasks: [],
  steps: [],
  routines: []
};

export const TaskGetters = {
  task: state => {
    return state.task;
  },
  tasks: state => {
    return state.tasks;
  },
  steps: state => {
    return state.steps;
  },
  routines: state => {
    return state.routines;
  }
};

export const TaskMutations = {
  setTask: (state, data) => {
    if (data) {
      const index = state.tasks.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.tasks];
        arr[index] = data;
        Vue.set(state, "tasks", arr);
      }
    }
    Vue.set(state, "task", data);
  },
  setTasks: (state, data) => {
    Vue.set(state, "tasks", data);
  },
  addTask: (state, data) => {
    Vue.set(state, "tasks", [data, ...state.tasks]);
  },
  removeTask: (state, data) => {
    const arr = state.tasks.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "tasks", arr);
  },
  //
  setStep: (state, data) => {
    if (data) {
      const index = state.steps.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.steps];
        arr[index] = data;
        Vue.set(state, "steps", arr);
      }
    }
  },
  setSteps: (state, data) => {
    Vue.set(state, "steps", data);
  },
  addStep: (state, data) => {
    Vue.set(state, "steps", [...state.steps, data]);
  },
  removeStep: (state, data) => {
    const arr = state.steps.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "steps", arr);
  },
  //
  setRoutine: (state, data) => {
    if (data) {
      const index = state.routines.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.routines];
        arr[index] = data;
        Vue.set(state, "routines", arr);
      }
    }
  },
  setRoutines: (state, data) => {
    Vue.set(state, "routines", data);
  },
  addRoutine: (state, data) => {
    Vue.set(state, "routines", [...state.routines, data]);
  },
  removeRoutin: (state, data) => {
    const arr = state.routines.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "routines", arr);
  }
};

export const TaskActions = {
  getTasks: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/clients/${data.id}/tasks${params}`)
      .then(response => {
        commit("setTasks", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch tasks from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getTask: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/tasks/${data.id}`)
      .then(response => {
        commit("setTask", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch task from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createTask: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/clients/${data.id}/tasks`, { task: data.params })
      .then(response => {
        commit("addTask", response.data);
        const message = `Task has been successfully added.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create task.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateTask: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/tasks/${data.id}`, { task: data })
      .then(response => {
        commit("setTask", response.data);
        const message = `Task ${response.data.name} has been successfully updated.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update task.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteTask: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/tasks/${data.id}`)
      .then(response => {
        commit("removeTask", data);
        const message = `Task ${data.name} has been successfully removed.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete task.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  getSteps: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/tasks/${data.id}/steps`)
      .then(response => {
        commit("setSteps", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch steps from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createStep: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/tasks/${data.id}/steps`, { step: data.params })
      .then(response => {
        commit("addStep", response.data);
        const message = `Step has been successfully added.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create step.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateStep: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/steps/${data.id}`, { step: data })
      .then(response => {
        commit("setStep", response.data);
        const message = `Step ${response.data.name} has been successfully updated.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update step.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteStep: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/steps/${data.id}`)
      .then(response => {
        commit("removeStep", data);
        const message = `Step ${data.name} has been successfully removed.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete step.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  getRoutines: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/tasks/${data.id}/routines`)
      .then(response => {
        commit("setRoutines", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch routines from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createRoutine: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/tasks/${data.id}/routines`, { routine: data.params })
      .then(response => {
        commit("addRoutine", response.data);
        const message = `Routine has been successfully added.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create routine.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateRoutine: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/routines/${data.id}`, { routine: data })
      .then(response => {
        commit("setRoutine", response.data);
        const message = `Routine has been successfully updated.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update routine.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  insertRoutinePrompt: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(
        `/api/v1/steps/${data.id}/routines/${data.routine_id}/insert_prompt`,
        { prompt: data.prompt }
      )
      .then(response => {
        commit("setRoutine", response.data);
        const message = `Prompt has been successfully updated to ${data.prompt}.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update routine.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteRoutine: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/routines/${data.id}`)
      .then(response => {
        commit("removeRoutine", data);
        const message = `Routine ${data.date} has been successfully removed.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete routine.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/task.store.js